import { AnchorHTMLAttributes } from 'react';

interface TransLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  'data-testid'?: string;
}

/**
 * Anchor for use in `<Trans components={{ link: <TransLink href="..." /> }} />`.
 *
 * Trans injects the translated text as children via `cloneElement`, so the
 * anchor is written without content at the call site. Rendering `{children}`
 * here means jsx-a11y sees a valid anchor, which is why call sites no longer
 * need `anchor-has-content` / `control-has-associated-label` disables.
 */
export const TransLink = ({ children, ...anchorProps }: TransLinkProps) => (
  <a {...anchorProps}>{children}</a>
);
